import chart_40 from "@images/home/features/40-percent.png";
import chart_72 from "@images/home/features/72-percent.png";
import chart_83 from "@images/home/features/83-percent.png";
import {BorderArticle} from "@ui/general/BorderArticle";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const Complete = () => {
  const {t} = useTranslation();

  const charts = [
    {
      id: 0,
      image: chart_40,
      desc: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.complete.chart_1"),
          }}
        />
      ),
    },
    {
      id: 1,
      image: chart_72,
      desc: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.complete.chart_2"),
          }}
        />
      ),
    },
    {
      id: 2,
      image: chart_83,
      desc: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.complete.chart_3"),
          }}
        />
      ),
    },
  ];

  return (
    <BorderArticle>
      <div className={styles.complete_wrapper}>
        <div className={styles.complete_wrap}>
          <div className={styles.complete_desc}>
            <h4
              dangerouslySetInnerHTML={{
                __html: t("page.features.packages.complete.title"),
              }}
            />

            <p
              dangerouslySetInnerHTML={{
                __html: t("page.features.packages.complete.desc"),
              }}
            />
          </div>

          <div className={styles.complete_charts}>
            <h6
              dangerouslySetInnerHTML={{
                __html: t("page.features.packages.complete.chart_title"),
              }}
            />

            <ul>
              {charts &&
                charts.length > 0 &&
                charts.map((chart) => (
                  <li key={chart.id}>
                    <img
                      src={chart.image}
                      alt={"chart"}
                    />
                    <span>{chart.desc}</span>
                  </li>
                ))}
            </ul>
          </div>
        </div>

        <p
          className={styles.complete_bottom}
          dangerouslySetInnerHTML={{
            __html: t("page.features.packages.complete.subtitle"),
          }}
        />
      </div>
    </BorderArticle>
  );
};
